import axios from 'axios';

const BASE_URL = 'https://pixabay.com/api/';
const API_KEY = '54337212-655e7339b0825c0fa1c24fc71';

export function getImagesByQuery(query) {
  const params = {
    key: API_KEY,
    q: query,
    image_type: 'photo',
    orientation: 'horizontal',
    safesearch: true,
  };

  return axios.get(BASE_URL, { params }).then(response => response.data);
}
